module.exports = __webpack_public_path__ + "img/new_vertical_pic.3350be45.png";